import { ThemeIcon } from '@mantine/core';
import { IconExternalLink } from '@tabler/icons-react';
import dayjs from 'dayjs';

import {
  getDocumentIcon,
  getDocumentIconColor,
} from 'src/Components/EntityLinks/utils/entityLinkIcons';
import humanizeFileSize from 'src/Utils/humanizeFileSize';

import styles from './LinkedDocumentItem.module.scss';
import { Props } from './LinkedDocumentItem.types';

const LinkedDocumentItem = ({ item, onClick }: Props) => {
  const mimeType = item.metadata?.mimeType as string | undefined;
  const size = item.metadata?.size as number | undefined;
  const type = item.metadata?.type as string | undefined;
  const createdAt = item.metadata?.createdAt as string | undefined;
  const isExternalLink = type === 'external_link';

  const DocIcon = isExternalLink ? IconExternalLink : getDocumentIcon(mimeType);

  return (
    <div className={styles.container} onClick={onClick}>
      <ThemeIcon
        size={36}
        radius="md"
        variant="light"
        color={isExternalLink ? 'blue' : getDocumentIconColor(mimeType)}
      >
        <DocIcon size={18} />
      </ThemeIcon>
      <div className={styles.content}>
        <span className={styles.title}>{item.title}</span>
        <span className={styles.subtitle}>
          {size != null && humanizeFileSize(size)}
          {size != null && createdAt && ' · '}
          {createdAt && dayjs(createdAt).format('DD/MM/YYYY')}
        </span>
      </div>
    </div>
  );
};

export default LinkedDocumentItem;
